/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Dont_Have_AccountInputs */



/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Auth_Login_Dont_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_login_dont_have_account = /** @type {((inputs?: Auth_Login_Dont_Have_AccountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Dont_Have_AccountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hast du kein Konto?")
	return /** @type {LocalizedString} */ ("Don't have an account?")
});